/*******************************************************************************
 * Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>
 *
 * This file mobile-devices.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * mobile-devices.js can not be copied and/or distributed
 * without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
 ******************************************************************************/

export function isAndroid() {
	let ua = navigator.userAgent;
	return ua.toLowerCase().indexOf('android') > -1;
}

export function isIOs() {
	let ua = navigator.userAgent;
	return /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
}

export function isFirefox() {
	let ua = navigator.userAgent;
	return ua.toLowerCase().indexOf('firefox') > -1;
}

export function isIE() {
	let ua = navigator.userAgent;
	return ua.indexOf('MSIE ') > -1    // IE 10 or older
		|| ua.indexOf('Trident/') > -1 // IE 11
		|| ua.indexOf('Edge/') > -1;
}

/**
 * IE 9 or older
 */
export function isIElt10() {
	return document.all && !window.atob; // IE 9 or older
}

export default function whatDevice() {
	if (isAndroid()) {
		return 'android'
	}
	else if (isIOs()) {
		return 'ios';
	}
	else if (isFirefox()) {
		return 'firefox';
	}
	else if (isIE()) {
		return 'ie';
	}

	else if (isIE()) {
		return 'ielt10';
	}

	else {
		return null;
	}

}



// WEBPACK FOOTER //
// ./resources/assets/js/tools/mobile-devices.js